module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    ref: "elAutocomplete",
    style: ({
      width: _vm.styleWidth + 'px'
    }),
    attrs: {
      "clearable": "",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.placeholderkeyword,
      "size": "medium"
    },
    on: {
      "clear": function($event) {
        return _vm.blurForBug()
      },
      "select": _vm.handleSelect
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchMbBlur.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchInput),
      callback: function($$v) {
        _vm.searchInput = $$v
      },
      expression: "searchInput"
    }
  }, [_c('el-button', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "17px",
      "color": "#000000"
    },
    attrs: {
      "slot": "append",
      "type": "warning",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchMbBtn
    },
    slot: "append"
  }, [_vm._v("搜尋\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53eff0e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/memoryrecent.vue
// module id = 677
// module chunks = 5 6 7 8 9 10